// ProtectedRoutes.jsx
import { Outlet, Navigate, useLocation } from "react-router-dom";

const ProtectedRoutes = () => {
  const userDetails = JSON.parse(localStorage.getItem("userDetails")); // Retrieve user details from localStorage
  const location = useLocation(); // Get current location

  return userDetails ? (
    <Outlet />
  ) : (
    <Navigate to="/login" replace state={{ from: location }} />
  );
};

export default ProtectedRoutes;
